<template>
  <component :is="errorComponent"></component>
</template>

<script>
import Error500 from '@/views/errors/500.vue';
import Error404 from '@/views/errors/404.vue';
import Error403 from '@/views/errors/403.vue';

export default {
  props: {
    error: {
      type: Object,
      required: true,
    },
  },
  computed: {
    errorComponent() {
      let component;
      switch (this.error.status) {
        case 404:
          component = Error404;
          break;
        case 403:
          component = Error403;
          break;
        default:
          component = Error500;
      }
      return component;
    },
  },
};
</script>
